module.exports = __webpack_public_path__ + "img/gift3.df6798fd.png";